import React from 'react';

const NotFoundPage = () => (
    <div className="page-wrapper">
        <h1>404: Page not found</h1>
    </div>

);

export default NotFoundPage;